export const HELMET_META_DATA = [
  {
    key: 'new-subscribe',
    title: 'SOOP 구독 개편 이벤트',
    keyword: 'SOOP, 숲, 개인방송, SOOP 구독, 구독, 이벤트',
    description: 'SOOP 구독 개편 이벤트',
  },
  {
    key: 'autopay-benefit',
    title: 'SOOP 자동결제 이벤트',
    keyword: 'SOOP, 숲, 개인방송, 별풍선, 구독, 퀵뷰, 이벤트',
    description: '자동결제하고 선물 받아가 숲~',
  },
  {
    key: 'soopi-daily-mission',
    title: 'SOOPi 미션이벤트',
    keyword: 'SOOP, 스트리머, 인터넷 방송, 개인 방송, 라이브, 라이브 방송',
    description: 'SOOPI 미션이벤트',
  },
  {
    key: 'soopi-conversation',
    title: 'SOOPi 대화하기 이벤트',
    keyword: 'SOOP, 스트리머, 인터넷 방송, 개인 방송, 라이브, 라이브 방송',
    description: 'SOOPI 대화하기 이벤트',
  },
  {
    key: 'subs_plus',
    title: 'SOOP 구독 플러스 이벤트',
    keyword: 'SOOP, 숲, 개인방송, SOOP 구독, 구독, 구독 플러스, 이벤트',
    description: 'SOOP 구독 플러스 이벤트',
  },
  {
    key: 'giftsub_event',
    title: '숲트리머 어드벤처 구독 선물권',
    keyword: 'SOOP, 스트리머, 인터넷 방송, 개인 방송, 라이브, 라이브 방송',
    description: '숲트리머 어드벤처, 구독 선물권 이벤트',
  },
  {
    key: 'subs-direct-change',
    title: '이벤트',
    keyword: 'SOOP, 숲, 스트리머, 인터넷 방송, 개인 방송, 라이브, 라이브 방송',
    description: 'SOOP 플러스 즉시 구독 이벤트',
  },
  {
    key: 'marketing-consent',
    title: 'SOOP 마케팅 수신 동의 이벤트',
    keyword: 'SOOP, 스트리머, 인터넷 방송, 개인 방송, 라이브, 라이브 방송',
    description: 'SOOP 마케팅 수신 동의 이벤트',
  },
  {
    key: 'freecshot-plus',
    title: 'FreecShot Plus 이벤트',
    keyword:
      'SOOP, 개인방송, FreecShot, FreecShot Plus, 프릭샷, 프릭샷플러스, 이벤트',
    description: 'SOOP FreecShot Plus 이벤트',
  },
  {
    key: 'savyg-event',
    title: 'SAVYG 이벤트',
    keyword: 'SOOP, 숲, 스트리머, 인터넷 방송, 개인 방송, 라이브, 라이브 방송',
    description: 'SOOP SAVYG 이벤트',
  },
];
